import styled from 'styled-components';
import { useIsMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { Badge } from './visual-elements/badge';
import { Icon } from './visual-elements/icon';
import { Image } from './visual-elements/image';
import { Video } from './visual-elements/video';

export const VisualElement = ({
  isFormSubmitted
}: {
  isFormSubmitted: boolean;
}) => {
  const { visualElement, visualElementMobile } = useSettings();

  const isMobile = useIsMobile();

  if (
    isFormSubmitted ||
    visualElement === 'none' ||
    !visualElement ||
    (isMobile && !visualElementMobile)
  )
    return null;

  const Element = {
    badge: Badge,
    icon: Icon,
    image: Image,
    video: Video
  }[visualElement];

  return (
    <WithShrink>
      <Element />
    </WithShrink>
  );
};

const WithShrink = styled.div`
  flex-shrink: 0;
  line-height: 0;
`;
